import React from 'react';
import PropTypes from 'prop-types';
import { CircularProgress } from '@material-ui/core';

import MultiSelectChip from './MultiSelectChip';
import AuthService from '../../../Api/AuthService';
import ApiManager from "../../../Api/ApiManager";

const ILOAD = 30;
const LOAD = 10;
const MAX = 99999;

class MultiUserSelectChip extends React.Component {
  static performMapping(data) {
    return data.map(user => ({
      label: user.username,
      value: user.id,
    }));
  }

  static mapSelected(allMapped, selected) {
    const ids = selected === [] || selected === null ? [] : selected;
    return allMapped.filter(entry => ids.includes(entry.value));
  }

  static unmapSelected(selected) {
    const ids = selected === [] || selected === null ? [] : selected;
    return ids.map(entry => (entry.value));
  }

  constructor(props) {
    super(props);
    this.state = {
      suggestions: [],
      suggestionTotal: null,
      selected: [],
      count: 0,
      left: 0,
      left_data: [],
      intial: false,
    };
  }

  componentDidMount() {
    this.loadSuggestions();
    // this.loadRest();
  }

  loadSuggestions = () => {
    // Intial batch query 
    ApiManager.getUsers(MAX)
      .then(response => response.json())
      .then((data) => {
        const allMapped = MultiUserSelectChip.performMapping(data && data.results ? data.results : data);

        this.setState(prevState => ({
          suggestions: allMapped,
          suggestionTotal: data && data.count ? data.count : null,
          left: 0,
          left_data: [],
          count: allMapped.length,
          intial: true,
        }));
      })
  };

  // loadRest = () => {
  //   // Grabbing the rest of the data
  //   const LARGE = 99999;
  //   return ApiManager.getUsers(LARGE, ILOAD)
  //     .then(response => response.json())
  //     .then((data) => {
  //       const allMapped = MultiUserSelectChip.performMapping(data && data.results ? data.results : data);

  //       this.setState(prevState => ({
  //         suggestionTotal: this.state.suggestionTotal + allMapped.length,
  //         left: allMapped.length,
  //         left_data: allMapped,
  //         intial: false,
  //       }));
  //     })
  // }

  newSuggestion = () => {
    if (this.state.left > 0) {
      let current_suggestion = this.state.suggestions;
      let left_suggestion = this.state.left_data;
      let count = this.state.count;
      let left = this.state.left;

      if (left_suggestion.length >= LOAD) {
        let hold = left_suggestion.splice(1,LOAD);
        current_suggestion = current_suggestion.concat(hold);
      } else {
        current_suggestion = current_suggestion.concat(left_suggestion);
        left_suggestion = [];
      }
      count = current_suggestion.length;
      left = left_suggestion.length;

      this.setState(prevState => ({
        suggestions: current_suggestion,
        left,
        left_data: left_suggestion,
        count,
        intial: false,
      }));
    } 
  }

  static getDerivedStateFromProps(props, state) {
    if (state.suggestions.length !== 0 && props.selected.length !== state.selected.length) {
      const authUser = props.selected.includes(AuthService.getProfile().user_id) ?
        [{
          label: AuthService.getProfile().username,
          value: AuthService.getProfile().user_id,
        }]
        : [];
      const otherUsers = state.suggestions.filter(x => {
        if (authUser[0]) {
          return props.selected.includes(x.value) && x.value !== authUser[0].value;
        }
        return props.selected.includes(x.value);
      });
      return {
        selected: [...authUser, ...otherUsers],
      };
    }

    // Return null if the state hasn't changed
    return null;
  }

  handleChange = (values) => {
    const { handleUpdate } = this.props;
    handleUpdate(MultiUserSelectChip.unmapSelected(values));
  };

  render() {
    const { ...others } = this.props;
    const { suggestions, selected, suggestionTotal, left_data, left, intial } = this.state;

    return (
      <div>
        {
          (suggestionTotal === null)
          ? <CircularProgress /> 
          : <MultiSelectChip
              {...others}
              handleUpdate={this.handleChange}
              suggestions={suggestions}
              selected={selected}
              suggestionTotal={suggestionTotal}
              paginationEnabled={true}
              loadMoreSuggestions={this.newSuggestion}
              all={suggestions.concat(left_data)}
              left={left}
              intial={intial}
            />
        }
      </div>
    );
  }
}

MultiUserSelectChip.defaultProps = {
  selected: [],
};

MultiUserSelectChip.propTypes = {
  handleUpdate: PropTypes.instanceOf(Object).isRequired,
  selected: PropTypes.arrayOf(Number),
};

export default MultiUserSelectChip;
